module.exports = __webpack_public_path__ + "img/KK0039C-PX.cd0e3a1d.jpg";